import axios, { AxiosInstance, AxiosResponse } from "axios";
import { useEffect } from "react";
import { ENDPOINTS } from "./api";
import { getCookie, removeCookie, setCookie } from "../modules/token";
import { ApiHeaders } from "../api/config/apiHeaders.constants";
import { useSelector } from "react-redux";
import { RootStateType } from "../redux/features/rootSlice";
export const baseInstance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    ...ApiHeaders.getAuthHeader(), // Include any additional headers from ApiHeaders
  },
});
export const userAddressBaseInstance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
function AxiosInterceptor({ children }: { children: JSX.Element }) {
  const storedClientId = useSelector((state: RootStateType) => state.configStateReducer.clientId);
  useEffect(() => {
    
    function setAuthorizationHeader(request: any) {
      // console.log("setting auth");
      try {
        const token = getCookie("app.at");
        request.headers.Authorization = `Bearer ${token}`;
        return request;
      } catch (error) {
        console.log(error);
      }
    }
    const interceptorBaseReq = baseInstance.interceptors.request.use(
      setAuthorizationHeader
    );
    const interceptorUserAddressReq =
      userAddressBaseInstance.interceptors.request.use(setAuthorizationHeader);
      
    async function errorHandler(error: any) {
      const originalConfig = error.config;
      if (error.response) {
        console.log(error.response);
        if (error.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          try {
            const body = {
              clientid: storedClientId,
              refresh_token: getCookie("app.rt"),
            };
            const { data } = await userAddressBaseInstance.post(
              ENDPOINTS?.REFRESH_TOKEN,
              body
            );
            if (!data.error) {
              const value = new Date().getTime() + data.expires_in * 1000;
              setCookie(`app.at=${data.access_token}`, value,storedClientId);
              setCookie(`app.at_exp=${data.expires_in}`, value,storedClientId);
              return await userAddressBaseInstance(originalConfig);
            }
          } catch (error: any) {
            removeCookie(`lastState=`, 0,storedClientId);
            removeCookie(`user=`, 0,storedClientId);
            setCookie(`app.at_exp=`, 0,storedClientId);
            setCookie(`app.at=`, 0,storedClientId);
            setCookie(`app.rt=`, 0,storedClientId);
            localStorage.clear();
          }
        } else {
          await Promise.reject(
            error?.response?.data || {
              message: "Something Went Wrong",
              statuscode: 500,
              error: true,
            }
          );
        }
      } else {
        await Promise.reject(new Error("Something Went Wrong", { cause: 500 }));
      }
    }
    function dummy(response: AxiosResponse) {
      return response;
    }
    const interceptorBaseRes = baseInstance.interceptors.response.use(
      dummy,
      errorHandler
    );
    const interceptorUserAddressRes =
      userAddressBaseInstance.interceptors.response.use(dummy, errorHandler);
    return () => {
      baseInstance.interceptors.request.eject(interceptorBaseReq);
      userAddressBaseInstance.interceptors.request.eject(
        interceptorUserAddressReq
      );
      baseInstance.interceptors.response.eject(interceptorBaseRes);
      userAddressBaseInstance.interceptors.response.eject(
        interceptorUserAddressRes
      );
    };
  }, []);
  return children;
}
export { AxiosInterceptor };